const CategoryIcon = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 19.25C3.02167 19.25 2.625 18.8533 2.625 18.375V9.625C2.625 9.14667 3.02167 8.75 3.5 8.75C3.97833 8.75 4.375 9.14667 4.375 9.625V18.375C4.375 18.8533 3.97833 19.25 3.5 19.25Z"
      fill="currentColor"
    />
    <path
      d="M8.75 22.1667C8.27167 22.1667 7.875 21.77 7.875 21.2917V6.70833C7.875 6.22999 8.27167 5.83333 8.75 5.83333C9.22833 5.83333 9.625 6.22999 9.625 6.70833V21.2917C9.625 21.77 9.22833 22.1667 8.75 22.1667Z"
      fill="currentColor"
    />
    <path
      d="M14 25.0833C13.5217 25.0833 13.125 24.6867 13.125 24.2083V3.79167C13.125 3.31334 13.5217 2.91667 14 2.91667C14.4783 2.91667 14.875 3.31334 14.875 3.79167V24.2083C14.875 24.6867 14.4783 25.0833 14 25.0833Z"
      fill="currentColor"
    />
    <path
      d="M19.25 22.1667C18.7717 22.1667 18.375 21.77 18.375 21.2917V6.70833C18.375 6.22999 18.7717 5.83333 19.25 5.83333C19.7283 5.83333 20.125 6.22999 20.125 6.70833V21.2917C20.125 21.77 19.7283 22.1667 19.25 22.1667Z"
      fill="currentColor"
    />
    <path
      d="M24.5 19.25C24.0217 19.25 23.625 18.8533 23.625 18.375V9.625C23.625 9.14667 24.0217 8.75 24.5 8.75C24.9783 8.75 25.375 9.14667 25.375 9.625V18.375C25.375 18.8533 24.9783 19.25 24.5 19.25Z"
      fill="currentColor"
    />
  </svg>
);
export default CategoryIcon;
